"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClinicsPage = ClinicsPage;
var jsx_runtime_1 = require("react/jsx-runtime");
function ClinicsPage() {
    return (0, jsx_runtime_1.jsx)("div", { children: "Clinics Page" });
}
